<template>
  <v-container
    fluid
    class="crafts-container"
    v-if="crafts.length > 0"
    id="crafts"
  >
    <title-3 :title="$t('activities.crafts')"></title-3>
    <v-row class="mt-10">
      <v-col
        v-for="(item, index) in crafts.slice(0, num)"
        :key="index"
        cols="12"
        sm="6"
        lg="4"
        class="py-lg-5 pr-lg-5"
      >
        <v-card
          class="card-activities pa-0 ma-lg-0 mx-auto"
          :href="getPdf(item.uploads)"
          download="test"
          target="_blank"
          :ripple="false"
        >
          <v-img :src="getImage(item.uploads)" height="145"> </v-img>
          <v-card-title class="text-white text-h6">{{
            item.title
          }}</v-card-title>
          <v-card-actions class="justify-end mt-n3 mx-0 pb-0">
            <v-btn
              class="btn-green px-5 mr-n2 text-h6 font-weight-black"
              :href="getPdf(item.uploads)"
              download
            >
              {{ $t("activities.btnDownload") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="justify-center mb-10">
      <v-btn
        class="first-btn px-8 py-7 mt-16"
        @click="changeCrafts()"
        v-if="crafts.length > 5"
      >
        {{ $t("activities.btnShowMoreCrafts") }}</v-btn
      >
    </v-row>
  </v-container>
</template>
<script>
import title3 from "../titles/title3.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: { title3 },
  name: "crafts",
  data() {
    return {
      num: 6,
      craftsList: [],
    };
  },
  async created() {
    // this.crafts = this.craftsList.slice(0, 6);
    this.fetchGetActivities();
  },
  computed: {
    ...mapGetters("activities", ["getActivities"]),
    ...mapGetters("tags", ["getTagsActive"]),
    crafts: {
      get: function () {
        return this.getCraftsByTags();
      },
      set: function (val) {
        this.craftsList = val;
      },
    },
  },
  methods: {
    ...mapActions("activities", ["fetchGetActivities"]),
    changeCrafts() {
      this.num = this.num + 6;
    },
    getCraftsByTags() {
      if (this.getCraftsByTags.length === 0) {
        return this.craftsList;
      }
      return this.craftsList.filter((craft) =>
        craft.tags.find((tag) =>
          this.getTagsActive
            .map((activeTag) => activeTag.name)
            .includes(tag.name[localStorage.getItem("language")])
        )
      );
    },
    getPdf(uploads) {
      if (uploads) {
        var uploadPdf = uploads.find((item) => item.main === true);
        return uploadPdf.path;
      }
    },
    getImage(uploads) {
      if (uploads) {
        var uploadImage = uploads.find((item) => item.main === false);
        return uploadImage?.path;
      }
    },
  },
  watch: {
    getActivities(val) {
      this.crafts = val.filter((crafts) => crafts.type === "crafts");
    },
  },
};
</script>
